function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('InputGroup'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-input-group'
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size,
          compact = this.compact;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-compact"), compact), _ref;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        classes = this.classes;
    return h("span", {
      "class": classes
    }, [$slots.default]);
  }
};